<script setup lang="ts">
import BaseSvg from './BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-hamburger" width="21" height="14" fill="none" viewBox="0 0 21 14">
    <defs>
      <path
        id="a"
        stroke="#33E672"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.48"
        d="M.74-.74h18.52"
      />
    </defs>
    <use
      xlink:href="#a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.48"
      transform="matrix(-1 0 .01123 -.99994 21 12)"
    />
    <use
      xlink:href="#a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.48"
      transform="matrix(-1 0 .01123 -.99994 21 6)"
    />
    <use
      xlink:href="#a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.48"
      transform="matrix(-1 0 .01123 -.99994 21 0)"
    />
  </BaseSvg>
</template>
